import React from "react";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { REIButton } from "../../components/ui";
import { httpPost } from "../../services/httpService";
import { ApiEndPoints } from "../../utils/endpoints";
import { USER_DETAIL } from "../../utils/constants";

const ArchistarUpgrade: React.FC = () => {
  const toastRef = React.useRef<Toast>(null);
  const [isChecked, setIsChecked] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const handleSubmit = async () => {
    const userDetails = JSON.parse(localStorage.getItem(USER_DETAIL) || "{}");

    setIsLoading(true);
    try {
      const result = await httpPost(
        `${ApiEndPoints.changeEmail}/AddArchistarSubscription/${userDetails.EmailAddress}`,
        {}
      );
      if (result.status === 200) {
        toastRef.current?.show({
          severity: "success",
          summary: "Success",
          detail:
            "Subscription successful! You will receive an email invitation to complete your ArchiStar Add-On account setup.",
          life: 5000,
        });
      } else {
        toastRef.current?.show({
          severity: "error",
          summary: "Error",
          detail: result.error || "An error occurred while processing your subscription.",
          life: 5000,
        });
      }
    } catch (error: any) {
      toastRef.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.message || "An error occurred while processing your subscription.",
        life: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className=" bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <Toast ref={toastRef} />

      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-xl flex flex-col items-center gap-4">
            <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="4" />
            <p className="text-lg font-semibold text-gray-700">Processing your subscription...</p>
          </div>
        </div>
      )}

      <div className="bg-white py-12 px-10">
        <div className="max-w-[1200px] mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-black mb-2 mt-4 md:mb-3 md:mt-3 tracking-wide">
            Add-on Archistar - Billing and Payment
          </h1>
          <div>
            <img
              src="https://info.realestateinvestar.com.au/hubfs/Archistar/Archistar%20Standard.png"
              alt="Archistar"
              className=""
            />
          </div>
        </div>
      </div>
      <div className="flex max-w-[2100px] mx-auto text-center text-xl gap-5 flex-col space-y-3">
        <p>Agree to the terms and conditions below and click the submit button to subscribe to ArchiStar Add-On.</p>
        <p>
          You will be billed $99 now, and $99 each month ongoing until you decide to cancel. Cancellation must be done
          by giving 14 days notice prior to your billing day by email to info@realestateinvestar.com.au
        </p>
        <p>
          If your payment is approved you will be sent an email invitation to complete your ArchiStar Add-On account
          setup. All prices include GST.
        </p>
        <p>Copies of invoices are available for download via "My Account".</p>
        <p>Accept Terms and Conditions.</p>
      </div>
      <div className="max-w-[2100px] mx-auto text-center text-lg gap-3">
        <input
          type="checkbox"
          id="termsAndConditions"
          data-testid="archup-chk-terms"
          className="w-5 h-5 text-blue-700 border-gray-300 rounded focus:ring-blue-700"
          onChange={(e) => setIsChecked(e.target.checked)}
        />
        *
      </div>
      <div className="flex items-center justify-center mt-4">
        <REIButton
          id="archup-btn-submit"
          label="Submit"
          onClick={() => {
            handleSubmit();
          }}
          disabled={!isChecked || isLoading}
        />
      </div>
    </div>
  );
};

export default ArchistarUpgrade;
